import { render, staticRenderFns } from "./PRDashboard.vue?vue&type=template&id=673f9716&scoped=true"
import script from "./PRDashboard.vue?vue&type=script&lang=js"
export * from "./PRDashboard.vue?vue&type=script&lang=js"
import style0 from "./PRDashboard.vue?vue&type=style&index=0&id=673f9716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673f9716",
  null
  
)

export default component.exports